<script setup>
  import { ref, watch, onMounted } from 'vue'
  import { useTemplateStore } from '@/stores/template'

  import BaseNavigation from '@/components/BaseNavigation.vue'

  // SimpleBar, for more info and examples you can check out https://github.com/Grsmto/simplebar/tree/master/packages/simplebar-vue
  import SimpleBar from 'simplebar'

  // Grab menu navigation arrays
  import menu from '@/data/menu'

  // import menuDocs from "@/data/menu-docs";

  // let navigationMenu = [...menu.main, ...menuDocs.main];

  let navigation = ref([...menu.main])

  // Component properties
  defineProps({
    withMiniNav: {
      type: Boolean,
      default: false,
      description: 'If the sidebar is in Mini Nav Mode'
    }
  })

  // Main store
  const store = useTemplateStore()

  // Admin Menu
  watch(
    () => store.isAdmin,
    isAdmin => {
      if (isAdmin) {
        console.log('PUBLINKER ADMIN OVERWATCH')
        navigation.value = [
          ...menu.main,
          ...menu.leadclump,
          ...menu.googleads,
          ...menu.homolog,
          ...menu.admin
        ]
      } else {
        navigation.value = [...menu.main]
      }
    }
  )

  watch(
    () => store.enabledModules,
    enabledModules => {
      if (enabledModules && enabledModules.includes('leadclump')) {
        const leadclumpMenuExists = navigation.value.some(
          menuItem => menuItem.name === 'Lead Clump'
        )
        if (!leadclumpMenuExists) {
          navigation.value = [...navigation.value, ...menu.leadclump]
        }
      }
      if (enabledModules && enabledModules.includes('googleads')) {
        const googleadsMenuExists = navigation.value.some(
          menuItem => menuItem.name === 'Google Ads'
        )
        if (!googleadsMenuExists) {
          navigation.value = [...navigation.value, ...menu.googleads]
        }
      }
    }
  )

  // Init SimpleBar (custom scrolling)
  onMounted(() => {
    try {
      new SimpleBar(document.getElementById('simplebar-sidebar'))
    } catch (e) {
      console.error('Sidebar SimpleBar', e)
    }
  })
</script>

<template>
  <!-- Sidebar -->
  <!--
    Sidebar Mini Mode - Display Helper classes

    Adding 'smini-hide' class to an element will make it invisible (opacity: 0) when the sidebar is in mini mode
    Adding 'smini-show' class to an element will make it visible (opacity: 1) when the sidebar is in mini mode
    If you would like to disable the transition animation, make sure to also add the 'no-transition' class to your element

    Adding 'smini-hidden' to an element will hide it when the sidebar is in mini mode
    Adding 'smini-visible' to an element will show it (display: inline-block) only when the sidebar is in mini mode
    Adding 'smini-visible-block' to an element will show it (display: block) only when the sidebar is in mini mode
  -->
  <nav
    id="sidebar"
    :class="{ 'with-mini-nav': withMiniNav }"
    aria-label="Main Navigation"
  >
    <slot>
      <!-- Side Header -->
      <div class="content-header">
        <slot name="header">
          <!-- Logo -->
          <RouterLink :to="{ name: 'landing' }" class="fw-semibold text-dual">
            <span class="smini-visible">
              <img
                class="publinker-minilogo sidebar"
                src="/assets/logo/publinker-website-favicon-color.png"
                alt="PubLinker"
              />
            </span>
            <span class="smini-hide fs-5 tracking-wider">
              <img
                class="publinker-logo sidebar"
                src="/assets/logo/publinker-low-resolution-logo-color-on-transparent-background.png"
                alt="PubLinker"
              />
              <!-- span class="fw-normal">Vue</span -->
            </span>
          </RouterLink>
          <!-- END Logo -->
        </slot>

        <!-- Extra -->
        <div>
          <slot name="header-extra"></slot>

          <!-- Close Sidebar, Visible only on mobile screens -->
          <button
            type="button"
            class="d-lg-none btn btn-sm btn-alt-secondary ms-1"
            @click="store.sidebar({ mode: 'close' })"
          >
            <i class="fa fa-fw fa-times"></i>
          </button>
          <!-- END Close Sidebar -->
        </div>
        <!-- END Extra -->
      </div>
      <!-- END Side Header -->

      <!-- Sidebar Scrolling -->
      <div id="simplebar-sidebar" class="js-sidebar-scroll">
        <slot name="content">
          <!-- Side Navigation -->
          <div class="content-side">
            <BaseNavigation
              :key="navigation.length"
              :nodes="navigation"
            ></BaseNavigation>
          </div>
          <!-- END Side Navigation -->
        </slot>
      </div>
      <!-- END Sidebar Scrolling -->
    </slot>
  </nav>
  <!-- END Sidebar -->
</template>
